<template>
  <v-list class="scrollable">
    <v-list-item
      v-for="repo in repoIndex.repos"
      :key="repo.id"
      :to="`/books/${repo.id}`"
    >
      <v-list-item-content>
        <v-list-item-title>{{ repo.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { newRepoIndex } from "@/domain/repo";

export default {
  name: "BookList",
  data() {
    return {
      repoIndex: newRepoIndex()
    };
  },
  async created() {
    this.repoIndex = await this.$ioc.repoService.getRepoIndex();
  },
  components: {}
};
</script>
